export default __webpack_public_path__ + "static/media/milestone 450.8befe71c.svg";